import styled from 'styled-components'

export const Container = styled.div`
  display: grid;
  padding: 0 var(--spacer-8);
`

Container.displayName = 'SectionEmptyStateContainer'

export const EmptyStateContent = styled.div`
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  border-radius: 0.25rem;
  border: 0.063rem solid var(--neutral-gray-800);
  box-shadow: 0 var(--spacer-4) var(--spacer-7) var(--spacer-2) #0000001f;
  z-index: 10;
`

EmptyStateContent.displayName = 'SectionEmptyStateContent'

export const EmptyStateHighLight = styled.div`
  border: solid 0.188rem var(--blue);
  top: 0;
  left: 0;
  height: 100%;
`

EmptyStateHighLight.displayName = 'EmptyStateHighLightContainer'

export const Highlight = styled.div`
  top: 0;
  right: 0;
  z-index: 11;
`

Highlight.displayName = 'SectionEmptyStateHighlight'

export const Showcase = styled.div`
  display: grid;
  grid-template-columns: repeat(12, 14rem);
  grid-gap: var(--spacer-4);

  overflow-x: scroll;
  margin: 1rem 0;

  scroll-behavior: smooth;
  -ms-overflow-style: none;
  scrollbar-color: transparent transparent;

  ::-webkit-scrollbar {
    display: none;
  }

  ::-moz-scrollbar {
    display: none;
  }
`

Showcase.displayName = 'SectionEmptyStateShowcase'

export const Category = styled.div`
  width: 12%;
  height: 1.25rem;
  background-color: var(--hc-color-neutral-500);
  border-radius: 0.25rem;
  margin: 1rem 0;
`

Category.displayName = 'SectionEmptyStateCategory'

export const Card = styled.div`
  color: var(--hc-color-neutral-600);
  border: solid 0.25rem var(--hc-color-neutral-600);
  aspect-ratio: 9/13;
`
